import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo1.png';
import _imports_1 from '@/assets/man.png';

const _withScopeId = n => (_pushScopeId("data-v-1158aa04"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"logo mt\" data-v-1158aa04><img src=\"" + _imports_0 + "\" alt=\"\" data-v-1158aa04><div class=\"ml title\" data-v-1158aa04><div style=\"font-size:30px;font-weight:bold;\" data-v-1158aa04>湖北省应急管理厅</div><div style=\"font-size:20px;\" data-v-1158aa04>安全生产培训综合管理平台</div></div></div>", 1);

const _hoisted_2 = {
  class: "menus"
};
const _hoisted_3 = {
  class: "nav-right fr mt"
};
const _hoisted_4 = {
  class: "el-dropdown-link"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down el-icon--right"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode("退出登录");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-img ml1",
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "clear"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_menus = _resolveComponent("menus");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_menu, {
    router: true,
    mode: "horizontal",
    "background-color": "#25476A",
    "text-color": "#7C91A6",
    "active-text-color": "#8BC34A",
    ellipsis: false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (item, index) => {
      return _openBlock(), _createBlock(_component_menus, {
        menu: item,
        key: index
      }, null, 8, ["menu"]);
    }), 128))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_dropdown, {
    onCommand: _ctx.handleCommand
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: "exit"
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createTextVNode(" 欢迎您，" + _toDisplayString(_ctx.info) + " ", 1), _hoisted_5])]),
    _: 1
  }, 8, ["onCommand"]), _hoisted_7]), _hoisted_8]);
}